var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v(_vm._s(_vm.pageTitle))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "faq" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.payroll,
                              expression: "payroll"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "payroll",
                            placeholder: "Enter Payroll Email"
                          },
                          domProps: { value: _vm.payroll },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.payroll = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.payrollError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.hr_email,
                              expression: "hr_email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "hr_email",
                            placeholder: "Enter HR Email"
                          },
                          domProps: { value: _vm.hr_email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.hr_email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.hr_emailError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.hr_admin_number,
                              expression: "hr_admin_number"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "hr_admin_number",
                            placeholder: "Enter HR Admin Contact"
                          },
                          domProps: { value: _vm.hr_admin_number },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.hr_admin_number = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.hr_admin_numberError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.employee_hotline,
                              expression: "employee_hotline"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "employee_hotline",
                            placeholder: "Enter Employee Hotline Number"
                          },
                          domProps: { value: _vm.employee_hotline },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.employee_hotline = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.employee_hotlineError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 forms-block" }, [
                    _c("div", { staticClass: "col-1 paddingleft0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block btn-success",
                          attrs: { type: "button" },
                          on: { click: _vm.addNewLink }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-2 col-11 paddingleft0" }, [
                      _vm._v(
                        "\n                                Would you like to add more Social Links?\n                            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.socialMediaLinks, function(
                    socialMediaLink,
                    index
                  ) {
                    return _c("div", { staticClass: "row col-12" }, [
                      _c("div", { staticClass: "col-12 forms-block" }, [
                        _c("div", { staticClass: "col-1 paddingleft0" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block btn-danger",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.removeSocialLink(index)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-times",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-11 paddingleft0" }, [
                          _c("div", { staticClass: "col-6 paddingleft0" }, [
                            _vm._m(4, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-9 paddingleft0" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    name: "socialMediaLinks[][social_title]",
                                    placeholder: "Select Social Media",
                                    id: "socialMediaLinks_" + index,
                                    label: "text",
                                    clearable: false,
                                    searchable: false,
                                    filterable: false,
                                    options: _vm.socialOptions
                                  },
                                  model: {
                                    value: socialMediaLink.social_title,
                                    callback: function($$v) {
                                      _vm.$set(
                                        socialMediaLink,
                                        "social_title",
                                        $$v
                                      )
                                    },
                                    expression: "socialMediaLink.social_title"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 paddingleft0" }, [
                            _vm._m(5, true),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9 paddingleft0" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: socialMediaLink.social_value,
                                    expression: "socialMediaLink.social_value"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "socialMediaLinks[][social_value]",
                                  placeholder: "Enter Social Media Link"
                                },
                                domProps: {
                                  value: socialMediaLink.social_value
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      socialMediaLink,
                                      "social_value",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("span", { staticClass: "form-control" }, [
                        _vm._v(_vm._s(_vm.lastUpdatedBy))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "col-12 paddingleft0" }, [
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          id: "addBenifitBtn",
                          type: "submit",
                          value: "Save"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.updateContactHR()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          id: "CancelBenifit",
                          type: "submit",
                          value: "Refresh"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.loadHRContact.apply(null, arguments)
                          }
                        }
                      })
                    ])
                  ])
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "payroll" } }, [
        _vm._v("Payroll Email :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "hr_email" } }, [
        _vm._v("HR Email :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", attrs: { for: "hr_admin_number" } },
        [_vm._v("HR Admin Contact :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", attrs: { for: "employee_hotline" } },
        [_vm._v("Employee Hotline :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Social Media :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Social Media Link :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "hr_email" } }, [
        _vm._v("Last Updated By :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cdb597e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cdb597e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/contactHR/UpdateContactHR.vue
// module id = null
// module chunks = 